import type { BlockNoteEditor } from "@blocknote/core";
import { selectThreadInEditor } from "./editorCommentSelection";
import { threadIdAtPoint } from "./editorCommentThread";
import { whenEditorViewReady } from "./editorComments";

const DRAG_THRESHOLD_PX = 8;

export const bindEditorCommentPointers = (
  editor: BlockNoteEditor,
  onDragSelect: () => void
) => {
  let cancelled = false;
  let node: HTMLElement | null = null;
  let down: { x: number; y: number } | null = null;

  const onMouseDown = (event: MouseEvent) => {
    down = { x: event.clientX, y: event.clientY };
  };

  const onMouseUp = (event: MouseEvent) => {
    const start = down;
    down = null;
    if (!start) return;

    const dragged =
      Math.hypot(event.clientX - start.x, event.clientY - start.y) >
      DRAG_THRESHOLD_PX;
    if (!dragged) return;
    if (threadIdAtPoint(editor, event.clientX, event.clientY)) return;

    window.setTimeout(() => {
      if (!cancelled) onDragSelect();
    }, 0);
  };

  const onClick = (event: MouseEvent) => {
    const threadId = threadIdAtPoint(editor, event.clientX, event.clientY);
    if (!threadId) return;
    selectThreadInEditor(editor, threadId);
  };

  whenEditorViewReady(editor, () => {
    if (cancelled) return;
    node = editor.prosemirrorView?.dom ?? null;
    node?.addEventListener("mousedown", onMouseDown);
    node?.addEventListener("mouseup", onMouseUp);
    node?.addEventListener("click", onClick);
  });

  return () => {
    cancelled = true;
    node?.removeEventListener("mousedown", onMouseDown);
    node?.removeEventListener("mouseup", onMouseUp);
    node?.removeEventListener("click", onClick);
  };
};
